import React from "react";
import { isNumber, get } from "lodash";
import PropTypes from "prop-types";
import DataCell from "./MetricDataCell";
import "./style.css";

const StyledRow = ({ children, ...rest }) => (
  <header className="metrics-group-item-row" {...rest}>
    {children}
  </header>
);

/* eslint react/prefer-stateless-function:0 */
class MetricGroupItem extends React.Component {
  render() {
    const { data, filteredSpeakers } = this.props;

    // Filter out 'CALLER' as this is synonymous with 'CUSTOMER'
    // Section order is strictly determined by speakers object in ./index.js
    const sections = filteredSpeakers.map((speaker) => speaker.toLowerCase());

    return (
      <StyledRow>
        <div>{get(data, "label", "--")}</div>
        {sections.map((section) => {
          let value = get(data, `speaker.${section}.val`, undefined);
          if (Number.isNaN(value) || !isNumber(value)) {
            value = "--";
          }
          const units = get(data, "units", "empty");
          return (
            <DataCell
              key={section}
              className="data-cell"
              units={units}
              value={value}
            />
          );
        })}
      </StyledRow>
    );
  }
}

export default MetricGroupItem;

MetricGroupItem.propTypes = {
  data: PropTypes.shape({
    label: PropTypes.string.isRequired,
    units: PropTypes.string.isRequired,
    speaker: PropTypes.shape({
      val: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
  }).isRequired,
};
